/* Screen registry. The shell renders exactly one of these per tab.

   Every tab is now a real screen wired to the API — the placeholders are gone.
   `Placeholder` itself is kept because a screen that has to degrade (a panel
   whose read failed hard, a surface not yet designed) still wants that frame. */
import type { Tab } from '../app/Shell'
import { Log } from './Log'
import { Plan } from './Plan'
import { Trends } from './Trends'
import { Vitals } from './Vitals'
import { Macros } from './Macros'
import { Journal } from './Journal'
import { Settings } from './Settings'

export { headingDate, monoDate } from './format'

export const SCREENS: Record<Tab, () => React.JSX.Element> = {
  LOG: Log,
  PLAN: Plan,
  TRENDS: Trends,
  VITALS: Vitals,
  MACROS: Macros,
  JOURNAL: Journal,
  SETTINGS: Settings,
}
